module.exports = __webpack_public_path__ + "static/media/background.5bc4b1ba.jpg";